export default {
  'Text': 'Текст',
  'Styles': 'Стили',
  'Text here': 'Введите текст здесь',
  'Add subtitles': 'Добавить субтитры',
  'Text Color': 'Цвет текста',
  'Outline': 'Контур',
  'Background': 'Фон',
  'Position': 'место',
}